// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__K9h0P"};